// Browser geolocation + reverse geocoding helpers shared by the screens that
// need the user's live position.

// Asks the browser for the current position. The first call triggers the
// browser's location permission prompt. Rejects with the GeolocationPositionError
// (err.code === 1 means the user denied permission).
export function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('unsupported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    });
  });
}

// Reverse-geocodes { lat, lng } via OpenStreetMap's Nominatim (no API key
// needed). Returns the raw address object, or null on any failure.
export async function reverseGeocode({ lat, lng }) {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=10&accept-language=en&lat=${lat}&lon=${lng}`;
    const res = await fetch(url);
    if (!res.ok) return null;
    const data = await res.json();
    return data.address || null;
  } catch {
    return null;
  }
}

export async function getDistrictName(coords) {
  const a = await reverseGeocode(coords);
  if (!a) return null;
  return a.state_district || a.county || a.city_district || a.city || null;
}
